import Button, { ButtonProps } from '@mui/material/Button';
import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';

type ButtonLinkProps = ButtonProps & Omit<LinkProps, 'to'> & { to: LinkProps['to'] };

const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>((props, ref) => (
  <Button component={Link} ref={ref} {...props} />
));

export default ButtonLink;
